import { faCheck, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import { Loading } from "../../ui";
import { useLeads } from "../LeadContext";

interface IProps {
	email: string;
}

export const EmailUploadValidator = (props: IProps): ReactElement => {
	const [exists, setExists] = useState();

	const leadContext = useLeads();

	useMemo(() => {
		const check = async () => {
			const checkExists = await leadContext.existsByEmail!(props.email);
			setExists(checkExists);
		};

		check();
	}, []);

	if (exists === undefined) {
		return <Loading />;
	}

	return exists ? (
		<FontAwesomeIcon icon={faTimes} style={{ color: "red" }} />
	) : (
		<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} />
	);
};
